import { AlreadyTranslatedText } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import { useOpenable } from '../../../../../../Modal/UseOpenable';
import LearningCollectionEditStore from '../../../../Edit/Store';
import { ModifiableExperiencesContext, SectionContext } from '../../../../Types';
import Store from '../Store';
import { ExperienceResource } from '../Types';
import Body from './ExperienceCatalog/Body';
import ActionButton from './ExperienceCatalog/Body/ActionButton';
import WarningModel from './ExperienceCatalog/Models/WarningModel';
import { LearningCollectionEditFormResource } from '../../../../Edit/Store/Types';

export interface Props {
  store: Store;
  resource: ExperienceResource;
  context: ModifiableExperiencesContext;
  learningCollectionStore: LearningCollectionEditStore;
  learningDesignName: AlreadyTranslatedText;
  sectionContext: SectionContext;
  learningCollectionEditFormResource: LearningCollectionEditFormResource;
}

function Experience({
  store,
  resource,
  context,
  learningCollectionStore,
  learningDesignName,
  sectionContext,
  learningCollectionEditFormResource,
}: Props) {
  const { open, close, modalState } = useOpenable();
  const commonProps = {
    store,
    resource,
    context,
    learningCollectionStore,
    learningDesignName,
    learningCollectionEditFormResource,
  };
  return (
    <div className="border-b-1 border-solid py-10 last:border-b-0">
      <Body {...commonProps} />
      <ActionButton
        {...commonProps}
        open={open}
        learningCollectionEditFormResource={learningCollectionEditFormResource}
      />
      <WarningModel
        {...commonProps}
        context={sectionContext}
        modalState={modalState}
        close={close}
      />
    </div>
  );
}

export default observer(Experience);
